import React from "react";

const PodcastHeader = () => {
  return (
    <div className="text-center mt-24">
      <h1 className="capitalize text-dark-blue text-6xl">
        Words that carry power!
      </h1>
      <p className="mt-5 w-full md:w-1/2 m-auto text-gray-500">
        Listen to words, answers to tough Bible questions, inspiring stories and
        practical lessons that will 10x the quality of your life only on The 360
        Believer Podcast.
      </p>
    </div>
  );
};

export default PodcastHeader;
